module.exports = __webpack_public_path__ + "static/media/excel-file.2b7a5562.svg";